import { FlexColumn } from '@make-software/cspr-design';
import styled from 'styled-components';

export const Container = styled(FlexColumn)`
  padding: 56px 0 80px;
`;

export const ButtonContainer = styled.div`
  padding: 24px 0;
`;
